import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";



export var UpdateTestRes;
export const UpdateTestTodo = createAsyncThunk('adminUpdateTest', async (data) => {
    try {
        const res = await axios({
            method: "put",
            url: process.env.REACT_APP_API_URL +  `admin/test/${data?.id}`,
            data: {
                "test_name": data?.test,
                "url_name":data?.url,
                "company_id": localStorage.getItem('companyId'),
                "status": data?.status,
                "modified_by": localStorage.getItem('user_id'),
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return UpdateTestRes = res.data

    } catch (error) {
        return UpdateTestRes = error.response.data
    }
})